import { SimplePaymentConfirmation } from './simple-payment-confirmation'

const INSURANCE_STRINGS = {
  failedDescription:
    "Le paiement de votre assurance n'a pas pu être traité. Veuillez réessayer depuis votre espace client ou contacter notre équipe si besoin.",
  failedTitle: "Paiement de l'assurance échoué",
  successDescriptionBuilder: (amountLabel?: string, referenceLabel?: string) =>
    `Votre paiement d'assurance${amountLabel ? ` de ${amountLabel}` : ''}${referenceLabel ?? ''} a bien été enregistré. Vous recevrez une confirmation par email sous peu.`,
  successTitle: 'Assurance confirmée !',
  unknownDescription:
    "Nous n'avons pas pu confirmer l'état de votre paiement d'assurance. Vérifiez votre espace client ou contactez notre équipe si besoin.",
  unknownTitle: 'Statut de paiement indisponible',
} as const

interface InsurancePaymentConfirmationProps {
  amountCents?: number
  reference?: string
  status: 'failed' | 'success' | 'unknown'
}

export function InsurancePaymentConfirmation({
  amountCents,
  reference,
  status,
}: InsurancePaymentConfirmationProps) {
  return (
    <SimplePaymentConfirmation
      reference={reference}
      amountCents={amountCents}
      status={status}
      strings={INSURANCE_STRINGS}
    />
  )
}
